module.exports = __webpack_public_path__ + "img/screenshot2.ef7afcce.png";